import { formatDistance } from "./uz/_lib/formatDistance.js";
import { formatLong } from "./uz/_lib/formatLong.js";
import { formatRelative } from "./uz/_lib/formatRelative.js";
import { localize } from "./uz/_lib/localize.js";
import { match } from "./uz/_lib/match.js";

/**
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali](https://github.com/Mukhammadali)
 */
export const uz = {
  code: "uz",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
export default uz;
